import React from 'react';
import ProspectPageProvider from "v4/contexts/ProspectPageContext";
import { SearchProvider } from "v4/contexts/SearchContext/SearchContext";
import { PROSPECT_SEARCH } from "v4/data/apiRoutes";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import useToggle from "v4/hooks/useToggle";
import ProspectMap from "v4/pages/front/Prospect/components/ProspectMap/ProspectMap";
import ProspectTabsSwitcher from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/ProspectTabsSwitcher";
import ProspectView from "v4/pages/front/Prospect/components/ProspectView/ProspectView";
import 'v4/pages/front/Prospect/ProspectPage.scss';

export default function ProspectPage() {
    const { currentRoute } = useNavigation();
    const { route } = currentRoute;
    const [isExpanded, toggleExpanded] = useToggle();

    const isMapPage = route?.native_identifier === 'detail_maps';

    return (
        <ProspectPageProvider key={currentRoute.groupId}>
            <ProspectPageContent isMapPage={isMapPage}
                                 isExpanded={isExpanded}
                                 toggleExpanded={toggleExpanded}
            />
        </ProspectPageProvider>
    )
}

function ProspectPageContent({ isMapPage, isExpanded, toggleExpanded }) {
    if (isMapPage) {
        return (
            <SearchProvider searchRouteName={PROSPECT_SEARCH} pageType="prospect-map">
                <ProspectMap/>
            </SearchProvider>
        );
    }

    return (
        <div className={`prospect__page ${isExpanded ? 'fullpage' : ''}`}>
            <ProspectView isExpanded={isExpanded} toggleExpanded={toggleExpanded}/>

            {!isMapPage && <ProspectTabsSwitcher/>}
        </div>
    );
}
